export const constants = {
    STATUS_ASSEMBLEIA: {
        ARQUIVIDA: { text:"Arquivada", value: 0},
        ENCERRADA: { text:"Encerrada", value: 1},
        FINALIZADA: { text:"Finalizado", value: 2},
        EMBREVE: { text:"Em Breve", value: 3},
        LIBERADA: { text:"Liberada", value: 4},
    }
} 
export const STATUS_REUNIAO_ADMIN = [
    constants.STATUS_ASSEMBLEIA.ARQUIVIDA.text,
    constants.STATUS_ASSEMBLEIA.LIBERADA.text,
    constants.STATUS_ASSEMBLEIA.EMBREVE.text,
    constants.STATUS_ASSEMBLEIA.ENCERRADA.text
];
export const STATUS_REUNIAO_COOPERADO_AND_VOTANTE =[
    constants.STATUS_ASSEMBLEIA.LIBERADA.text,
    constants.STATUS_ASSEMBLEIA.EMBREVE.text,
    constants.STATUS_ASSEMBLEIA.FINALIZADA.text
]
  
  